import { createSelector } from 'reselect';
import CompliancePredesResdesInterchangeEdiMessageColumns from '../../containers/CompliancePredesResdesInterchangeEdiMessageColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.PREDES_AND_RESDES_INTERCHANGES.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.PREDES_AND_RESDES_INTERCHANGES.isLoading;

export const getData =
  ReportDefinitions.PREDES_AND_RESDES_INTERCHANGES.getDataFunction();

export const getColumns =
  createSelector(getData, CompliancePredesResdesInterchangeEdiMessageColumns);
